/* FW Reviews by use case — v2.
   Reads its data from the JSON blob the section prints, so all copy stays in the
   theme editor. Runs once per section instance, and re-runs in the editor. */
(function(){
  'use strict';

  function init(root){
    if(!root || root.dataset.fwRvReady === '1') return;
    root.dataset.fwRvReady = '1';

    var blob = root.querySelector('.fw-rv-data');
    if(!blob) return;
    var cfg;
    try { cfg = JSON.parse(blob.textContent); } catch(e){ return; }

    var starId  = root.getAttribute('data-star');
    var DWELL   = cfg.dwell || 7000;

    /* group the flat review list under its category, dropping empty categories */
    var CATS = [];
    (cfg.cats || []).forEach(function(c){
      var rs = (cfg.reviews || []).filter(function(r){ return r.c === c.i; });
      if(rs.length) CATS.push({ label:c.label, r:rs });
    });
    if(!CATS.length){ root.style.display='none'; return; }

    var toggle = root.querySelector('.fw-rv-toggle');
    var slider = root.querySelector('.fw-rv-slider');
    var stage  = root.querySelector('.fw-rv-stage');
    var side   = root.querySelector('.fw-rv-side');
    var bars   = root.querySelector('.fw-rv-bars');
    var idxEl  = root.querySelector('.fw-rv-idx');
    var panel  = root.querySelector('.fw-rv-panel');
    var nextB  = root.querySelector('.fw-rv-next');
    var prevB  = root.querySelector('.fw-rv-prev');
    if(!toggle || !stage || !panel) return;

    var cat = 0, qi = 0, quotes = [], fills = [], t0 = 0, hover = false, vis = false;

    function star(){
      var s = document.createElementNS('http://www.w3.org/2000/svg','svg');
      s.setAttribute('viewBox','0 0 20 20');
      var u = document.createElementNS('http://www.w3.org/2000/svg','use');
      u.setAttribute('href','#'+starId);
      u.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href','#'+starId);
      s.appendChild(u); return s;
    }
    function starRow(n){
      var d = document.createElement('div'); d.className = 'fw-rv-stars';
      var k = Math.max(1, Math.min(5, n || 5));
      for(var i=0;i<k;i++) d.appendChild(star());
      return d;
    }

    /* ---- the theme's sliding pill toggle ---- */
    var btns = [];
    CATS.forEach(function(c,i){
      var b = document.createElement('button');
      b.className = 'fw-rv-tg'; b.type = 'button'; b.setAttribute('role','tab');
      b.setAttribute('aria-selected', i===0 ? 'true' : 'false');
      b.setAttribute('tabindex', i===0 ? '0' : '-1');
      b.textContent = c.label;
      b.addEventListener('click', function(){ setCat(i); });
      b.addEventListener('keydown', function(e){
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if(!d) return;
        e.preventDefault();
        var n = (btns.indexOf(document.activeElement) + d + btns.length) % btns.length;
        setCat(n); btns[n].focus();
      });
      toggle.appendChild(b); btns.push(b);
    });
    function moveSlider(i){
      var b = btns[i]; if(!b || !slider) return;
      slider.style.width = b.offsetWidth + 'px';
      slider.style.transform = 'translateX(' + (b.offsetLeft - 4) + 'px)';
      btns.forEach(function(x,k){
        x.setAttribute('aria-selected', k===i ? 'true' : 'false');
        x.setAttribute('tabindex', k===i ? '0' : '-1');
      });
      /* keep the active pill in view when the rail scrolls on mobile */
      var sc = root.querySelector('.fw-rv-tgscroll');
      if(sc && sc.scrollWidth > sc.clientWidth){
        var want = b.offsetLeft - (sc.clientWidth - b.offsetWidth)/2;
        sc.scrollTo({ left: Math.max(0, want), behavior:'smooth' });
      }
    }

    function words(el, txt){
      txt.split(/\s+/).forEach(function(w,i){
        var s = document.createElement('span'); s.className = 'fw-rv-w';
        var t = document.createElement('i'); t.textContent = w;
        t.style.transitionDelay = (0.02 + i*0.018) + 's';
        s.appendChild(t); el.appendChild(s);
        el.appendChild(document.createTextNode(' '));
      });
    }

    function build(){
      quotes.forEach(function(e){ e.remove(); }); quotes = [];
      CATS[cat].r.forEach(function(d){
        var len = d.q.length;
        var el = document.createElement('div');
        el.className = 'fw-rv-q' + (len > 250 ? ' is-xlng' : len > 145 ? ' is-lng' : '');
        el.appendChild(starRow(d.s));
        var bq = document.createElement('blockquote'); words(bq, d.q);
        el.appendChild(bq);
        var by = document.createElement('div'); by.className = 'fw-rv-by';
        var col = document.createElement('div');
        var nm = document.createElement('div'); nm.className = 'fw-rv-nm'; nm.textContent = d.n || '';
        col.appendChild(nm);
        if(d.m){
          var mt = document.createElement('div'); mt.className = 'fw-rv-mt'; mt.textContent = d.m;
          col.appendChild(mt);
        }
        by.appendChild(col);
        by.style.transitionDelay = (0.12 + 0.01 * d.q.split(/\s+/).length) + 's';
        el.appendChild(by);
        stage.appendChild(el); quotes.push(el);
      });
    }

    /* size to the featured quote, not the tallest in the set — the CSS transition
       carries the panel between heights so nothing jumps */
    function sizeStage(){
      var e = quotes[qi] || quotes[0];
      if(e && e.offsetHeight) stage.style.height = e.offsetHeight + 'px';
    }

    function buildBars(){
      if(!bars) return;
      bars.innerHTML = ''; fills = [];
      var n = CATS[cat].r.length;
      if(n < 2){ bars.style.display = 'none'; return; }
      bars.style.display = '';
      CATS[cat].r.forEach(function(d,i){
        var b = document.createElement('button');
        b.className = 'fw-rv-bar'; b.type = 'button';
        b.setAttribute('aria-label','Review ' + (i+1) + ' of ' + n + (d.n ? ', ' + d.n : ''));
        var f = document.createElement('i'); b.appendChild(f);
        b.addEventListener('click', function(){ if(i !== qi) show(i); });
        bars.appendChild(b); fills.push(f);
      });
    }

    /* the reviews not currently featured sit beside it — click one to promote it */
    function buildSide(){
      if(!side) return;
      side.innerHTML = '';
      CATS[cat].r.forEach(function(d,i){
        if(i === qi) return;
        var b = document.createElement('button');
        b.className = 'fw-rv-item'; b.type = 'button';
        b.setAttribute('aria-label','Show the review from ' + (d.n || 'this customer'));
        b.appendChild(starRow(d.s));
        var p = document.createElement('p'); p.className = 'fw-rv-sq'; p.textContent = d.q;
        var n = document.createElement('div'); n.className = 'fw-rv-sn';
        n.textContent = d.m ? (d.n + ' — ' + d.m) : d.n;
        b.appendChild(p); b.appendChild(n);
        b.addEventListener('click', function(){ show(i); });
        side.appendChild(b);
      });
    }

    function pad(n){ return (n < 10 ? '0' : '') + n; }

    function show(i, instant){
      quotes.forEach(function(e,k){
        if(k === i){ e.classList.remove('is-out'); e.classList.add('is-on'); }
        else if(e.classList.contains('is-on')){
          e.classList.remove('is-on');
          if(!instant){
            e.classList.add('is-out');
            setTimeout(function(){ e.classList.remove('is-out'); }, 280);
          }
        }
      });
      qi = i;
      sizeStage();
      buildSide();
      fills.forEach(function(f,k){ if(k < i) f.style.width = '100%'; else if(k > i) f.style.width = '0%'; });
      if(idxEl){
        var n = CATS[cat].r.length;
        idxEl.innerHTML = n > 1 ? pad(i+1) + ' <span>/ ' + pad(n) + '</span>' : '';
      }
      t0 = performance.now();
    }

    function go(s){ if(quotes.length) show((qi + s + quotes.length) % quotes.length); }

    function setCat(i){
      if(i === cat) return;
      cat = i; moveSlider(i);
      quotes.forEach(function(e){
        if(e.classList.contains('is-on')){ e.classList.remove('is-on'); e.classList.add('is-out'); }
      });
      setTimeout(function(){ build(); buildBars(); show(0, true); }, 220);
    }

    if(nextB) nextB.addEventListener('click', function(){ go(1); });
    if(prevB) prevB.addEventListener('click', function(){ go(-1); });
    ['pointerenter','focusin'].forEach(function(e){
      panel.addEventListener(e, function(){ hover = true; });
    });
    ['pointerleave','focusout'].forEach(function(e){
      panel.addEventListener(e, function(){ hover = false; t0 = performance.now(); });
    });

    /* Paint the first review synchronously. It must NOT wait on requestAnimationFrame:
       rAF is suspended in a background tab, so a PDP opened in a new tab (every ad click
       that opens a new window) would show an empty panel until the visitor hit a category. */
    build(); buildBars(); show(0, true);

    /* Measurement only — safe to repeat, and repeated because the pill widths the slider
       is sized from are wrong until layout settles and the webfont swaps in. */
    function measure(){ moveSlider(cat); sizeStage(); }
    measure();
    requestAnimationFrame(measure);
    setTimeout(measure, 250);

    var rt;
    window.addEventListener('resize', function(){
      clearTimeout(rt);
      rt = setTimeout(measure, 120);
    });
    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(measure);
    }

    new IntersectionObserver(function(es){
      es.forEach(function(e){ vis = e.isIntersecting; });
    },{ threshold:.2 }).observe(panel);

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (function tick(ts){
      requestAnimationFrame(tick);
      if(reduced || !fills[qi] || !vis || hover){ t0 = ts; return; }
      var k = Math.min(1, (ts - t0) / DWELL);
      fills[qi].style.width = (k * 100) + '%';
      if(k >= 1) go(1);
    })(performance.now());
  }

  function boot(scope){
    (scope || document).querySelectorAll('.fw-rv').forEach(init);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(); });
  } else {
    boot();
  }
  /* theme editor */
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
